import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-internet-connectivity',
  templateUrl: './internet-connectivity.component.html',
  styleUrls: ['./internet-connectivity.component.scss']
})
export class InternetConnectivityComponent {

  connectionStatus: 'ONLINE' | 'OFFLINE' = 'ONLINE';

  @HostListener('window:offline')
  setNetworkOffline(): void {
    this.connectionStatus = 'OFFLINE';
  }

  @HostListener('window:online')
  setNetworkOnline(): void {
    this.connectionStatus = 'ONLINE';
  }

}
